export default "__VITE_ASSET__wOfIiMp1__"